<template>
  <div>
    <section class="here">
      <div class="here_box" style="text-align: left">
        <a
          :title="detailData.categoryName"
          style="cursor: pointer"
          v-if="detailData.category"
          >{{ detailData.category.name }}</a
        >
        &nbsp;/&nbsp;&nbsp;{{ detailData.name }}
      </div>
    </section>
    <div class="product_box">
      <div class="product_show">
        <div class="product_show_pic">
          <el-carousel
            arrow="always"
            height="450px"
            ref="remarkCarusel"
            class="pic_carusel"
            :autoplay="true"
          >
            <el-carousel-item
              v-for="(item, index) in detailData.images"
              :key="index"
            >
              <el-image :src="imgPrefix + item"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="product_show_info">
          <div class="product_title">
            <ul>
              {{
                detailData.name
              }}
            </ul>
            <li></li>
            <p>{{ detailData.subTitle }}</p>
          </div>
        </div>
        <div class="middlePc">
          <div class="price">
            <p>
              <span><i>现价</i>￥{{ detailData.salesPrice }}</span>
              <span
                ><i>全新</i><b>￥{{ detailData.originalPrice }}</b></span
              >
            </p>
          </div>
          <div class="otherService">
            <div
              class="label"
              v-for="(item, index) in detailData.labelList"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="container">
            <p>
              <span>运费：{{ detailData.freightAmount }}元</span>
              <span>销量：{{ detailData.salesQuantity }}</span>
            </p>
          </div>
          <div class="wrapper" v-if="this.coupon.length != 0">
            <span>领劵：</span>
            <div class="w-box">
              <div class="w-label" v-for="(item, index) in coupon" :key="index">
                满{{ item.usingCondition }}减{{ item.discount }}
              </div>
            </div>
          </div>
          <div class="specification">
            <van-field
              name="radio"
              :label="item.name"
              v-for="(item, index) in this.specificationList"
              :key="index"
            >
              <template #input>
                <van-radio-group
                  v-model="radioArray[index]"
                  class="colour"
                  @change="onChangeColour(index)"
                >
                  <van-radio
                    checked-color="#ee0a24"
                    :name="items.id"
                    v-for="items in item.valueList"
                    :key="items.id"
                    @change="handleRadioChanges(index, items.id)"
                    >{{ items.textValue }}</van-radio
                  >
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="wrapper">
            <span>支付方式：</span>
            <span>微信/支付宝</span>
          </div>
          <div class="report" v-if="this.QcReportData">
            <h2>闲至优品</h2>
            <h3>{{ QcReportData.name }}</h3>
            <van-divider />
            <div class="report_inspector">
              <img :src="imgPrefix + QcReportData.inspectorAvatar" alt="" />
              <div>
                <p>{{ QcReportData.inspectorName }}</p>
                <p>{{ QcReportData.inspectorLevel }}</p>
              </div>
              <img src="../assets/a3_hege.png" alt="" />
            </div>
            <div class="result">
              <div class="result-head">检查结果</div>
              <p>{{ QcReportData.content }}</p>
              <van-divider />
              <van-collapse v-model="activeNames" accordion>
                <van-collapse-item name="1">
                  <template #title>
                    <div class="vantItem">
                      检查功能<span> <van-icon name="checked" />全通过 </span>
                    </div>
                  </template>
                  <div class="sectorization">
                    <span
                      v-for="(item, index) in QcReportData.functionalEvaluation"
                      :key="index"
                    >
                      {{ item }}
                    </span>
                    <p>官方自营 | 七天包退换 | 180天质保</p>
                  </div>
                </van-collapse-item>
              </van-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--浮动-->

    <transition
      enter-active-class="animated fadeInDown"
      leave-active-class="animated fadeOutUp"
      :duration="500"
    >
      <div class="product_fixed" id="top" v-show="isFixed">
        <div class="product_fd_box">
          <div class="product_fd_title">
            <img
              v-if="detailData.icon"
              :src="imgPrefix + detailData.icon"
              width="60"
            />
            <ul>
              <h2>{{ detailData.name }}</h2>
              <p>{{ detailData.subTitle }}</p>
            </ul>
          </div>
          <div class="product_fd_buypt">
            <li>
              <a @click="download" target="_blank" title="闲至优品">
                <img src="../assets/logo.png" alt="" />
                <p>闲至优品</p>
              </a>
            </li>
          </div>
        </div>
      </div>
    </transition>

    <!--浮动-->
    <section class="product_body_main">
      <div class="product_show_box">
        <div class="product_contents" v-html="detailData.description"></div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      detailData: {},
      id: this.$route.query.id,
      skuId: this.$route.query.skuId,
      isFixed: false,
      imgPrefix: "http://qiniu.xzypapp.com/",
      coupon: [],
      value: "1",
      speArr: [], //规格数组
      QcReportData: "",
      activeNames: ["1"],
      specificationList: [],
      radioArray: [],
      ruleForm: {},
    };
  },
  mounted() {
    this.getInfo(this.id);
    this.getcoupon(this.skuId);
    this.getSpecification(this.id);
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    getInfo(id) {
      this.axios({
        method: "post",
        url: "api/product/get",
        data: {
          id: id,
        },
      }).then((res) => {
        this.detailData = res.data.data;
        if (this.detailData.giftList.length == 0) {
          delete this.detailData.giftList;
        }
        this.detailData.images = this.detailData.images.split("|");
        console.log(this.detailData);
      });
    },
    download() {
      this.$router.push({
        name: "download",
      });
    },
    getcoupon(id) {
      this.axios({
        method: "post",
        url: "api/coupon/findByMultipleId",
        data: {
          goodsId: id,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.coupon = res.data.data;
        }
      });
    },
    getSpecification(id) {
      this.axios({
        method: "post",
        url: "api/param/findByProductId",
        data: {
          productId: id,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.specificationList = res.data.data;
          if (this.specificationList) {
            this.specificationList.forEach((e, index) => {
              this.radioArray[index] = e.valueList[0].id;
            });
          }
          this.speArr = data.map((e, i) => {
            return e.valueList[0].id;
          });
          this.getQcReport(id, this.speArr);
        }
      });
    },
    getQcReport(id, speArr) {
      this.axios({
        method: "post",
        url: "api/goods/findByValueIdList",
        data: {
          productId: id,
          valueIdList: speArr,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.detailData.salesPrice = res.data.data.salesPrice;
          if (res.data.data.report) {
            this.QcReportData = res.data.data.report;
            this.QcReportData.functionalEvaluation =
              this.QcReportData.functionalEvaluation.split("|");
          }
        }
      });
    },
    // 选择规格后的事件
    onChangeColour(val) {
      console.log(this.radioArray);
      this.getQcReport(this.$route.query.id, this.radioArray);
    },
    handleRadioChanges(index, strnum) {
      console.log(this.radioArray);
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量
      this.isFixed = scrollTop > 70 ? true : false; // 如果滚动到顶部了，this.isFixed就为true
    },
  },
};
</script>

<style  lang='less' scoped>
@import "../assets/softmooni.css";


.pic_carusel {
  text-align: center;
  padding: 30px 0px;
  .el-image {
    width: 450px;
  }
  /deep/ .el-carousel__indicator--horizontal {
    display: none;
  }
}
.imgUl {
  overflow: hidden;
  width: 100%;
  height: 100%;
  z-index: 99;
  /deep/.el-carousel__arrow {
    display: block;
  }
  /deep/.el-image {
    img {
      padding: 20px 8px;
      width: 100px;
    }
  }
}
.lisColor {
  color: white;
}
.product_contents{
   /deep/ img{
        width: 100%;
    }
}
.middlePc {
  box-sizing: border-box;
  width: 560px;
  float: right;
  .price {
    p {
        text-align: left;
      i {
        font-style: normal;
        color: #666;
      }
      span {
        color: red;
        font-size: 24px;
        b {
          font-weight: normal;
          color: #666;
          text-decoration: line-through;
        }
      }
    }
  }
  .specification {
    background: #fcfafa;
  }
  /deep/.van-radio {
    margin-bottom: 3px;
    float: left;
    margin-right: 5px;
  }
  /deep/ .van-cell {
    background: #fcfafa;
    .van-field__label {
      width: auto;
    }
    padding: 5px 0px;
    .van-cell__title {
      color: #999;
      font-size: 14px;
    }
  }
  .otherService {
    width: 100%;
    height: 30px;
    margin-top: 0.3125rem;

    .label {
      height: 30px;
      border-radius: 0.375rem;
      margin-right: 0.625rem;
      margin-bottom: 10px;
      text-align: center;
      line-height: 1.25rem;
      float: left;
      background: -webkit-linear-gradient(left, #ff1f03, #ff7d34);
      color: #fff;
      font-size: 12px;
      padding: 0 8px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
    }
  }

  .container {
    width: 100%;
    height: 30px;
    margin-top: 5px;
    margin-bottom: 5px;

    p {
      width: 100%;
      float: left;

      span {
        color: #999;
        font-size: 15px;
        float: right;

        &:first-child {
          float: left;
        }
      }
    }
  }


  .wrapper {
    width: 100%;
    float: left;
    margin-bottom: 5px;
    span {
      color: #999;
      font-size: 14px;
      float: left;
    }
    .w-box {
      float: left;
      width: 80%;
      height: 20px;
      overflow: hidden;

      .w-label {
        font-size: 14px;
        margin-right: 0.3125rem;
        float: left;
        color: #fff;
        width: 85px;
        background: #ff4501;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sharePc.vue